import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/toast/toast.component';
import { FloatingChatButtonComponent } from './shared/components/floating-chat-button/floating-chat-button.component';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, FloatingChatButtonComponent],
  template: `
    <app-toast />
    @if (!isProduction) {
      <div class="env-ribbon">PRUEBAS</div>
    }
    <router-outlet />
    <app-floating-chat-button />
  `,
  styles: [`
    .env-ribbon {
      position: fixed;
      top: 12px;
      right: -34px;
      z-index: 999999;
      background: #f59e0b;
      color: #fff;
      font-size: 0.65rem;
      font-weight: 800;
      letter-spacing: 0.15em;
      text-transform: uppercase;
      padding: 0.25rem 2.5rem;
      transform: rotate(45deg);
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
      pointer-events: none;
    }
  `],
})
export class AppComponent {
  isProduction = environment.firebase.projectId === 'micablego-autogestion';
}
